import axios from 'axios'
import { get, isEmpty } from 'lodash'
import qs from 'qs'
import router from '@/router/index'
import { ElMessage } from 'element-plus'

function createService() {
  // 创建一个 axios 实例
  const service = axios.create()

  // HTTP request 拦截器
  service.interceptors.request.use(
    (config) => config,
    (error) => {
      console.log(error)
      // 失败
      return Promise.reject(error)
    }
  )

  // HTTP response 拦截器
  service.interceptors.response.use(
    (response) => {
      if ((response.headers['content-disposition'] || !/^application\/json/.test(response.headers['content-type'])) && response.status === 200) {
        return response
      } else if (response.data.size) {
        response.data.code = 500
        response.data.message = '服务器内部错误'
        response.data.success = false
      } else if (response.data.code && response.data.code !== 200) {
        ElMessage.error(response.data.message)
      }
      return response.data
    },
    (error) => {
      const err = (text: string) => {
        ElMessage.error(error.response && error.response.data && error.response.data.message ? error.response.data.message : text)
      }
      if (error.response && error.response.data) {
        switch (error.response.status) {
          case 404:
            err('服务器资源不存在')
            break
          case 500:
            err('服务器内部错误')
            break
          case 401:
            throttle(() => {
              err('登录状态已过期，需要重新登录')
              localStorage.clear()
              router.push({ name: 'login' })
            })()
            break
          case 403:
            err('没有权限访问该资源')
            break
          default:
            err('未知错误！')
        }
      } else {
        err('请求超时，服务器无响应！')
      }
      return Promise.reject(error.response && error.response.data ? error.response.data : null)
    }
  )
  return service
}

//节流
function throttle(fn, wait = 1500) {
  return function () {
    let context = this
    if (!throttle.timer) {
      fn.apply(context, arguments)
      throttle.timer = setTimeout(function () {
        throttle.timer = null
      }, wait)
    }
  }
}

function stringify(data) {
  return qs.stringify(data, { allowDots: true, encode: false })
}

/**
 * @description 创建请求方法
 * @param service
 * @param externalService
 */
function createRequest(service) {
  return function (config) {
    const env = import.meta.env
    const token = localStorage.getItem('token')
    const configDefault = {
      headers: Object.assign(
        {
          Authorization: 'Bearer ' + token,
          'Accept-Language': 'zh_CN',
          'Content-Type': get(config, 'headers.Content-Type', 'application/json;charset=UTF-8')
        },
        config.headers
      ),

      timeout: 100000,
      data: {}
    }

    delete config.headers
    // return
    const option = Object.assign(configDefault, config)

    // json
    if (!isEmpty(option.params)) {
      option.url = option.url + '?' + stringify(option.params)
      option.params = {}
    }
    option.baseURL = env.VITE_APP_PROXY_PREFIX + '/api/v1'
    return service(option)
  }
}

export const service = createService()
export const request = createRequest(service)
